import { useCallback } from 'react';

import { Address, hashMessage } from 'viem';
import { useSignMessage as useWagmiSignMessage } from 'wagmi';

import { useAuth } from '@contexts/common/AuthorizationContext';

import { mapWagmiError } from '@helpers/common/error.helpers';

import { prepareHashMessage } from '@utils/sign.utils';

import showToast from '@components/common/Toast';

import { ToastType } from '@constants/common/toast.constants';

import { HashMessageData } from '@app-types/common/common.types';

interface UseSignMessage {
  signData: (data: HashMessageData) => Promise<string | undefined>;
  isPending: boolean;
}

export const useSignMessage = (): UseSignMessage => {
  const { account } = useAuth();
  const { signMessageAsync, isPending } = useWagmiSignMessage({
    mutation: {
      onError: (error: Error | null) => {
        console.error('Error signing message', error);
        showToast({ title: mapWagmiError(error) }, ToastType.Error);
      },
    },
  });

  const signData = useCallback(
    async (data: HashMessageData): Promise<string> => {
      const message = prepareHashMessage(data);

      return signMessageAsync({
        account: account as Address,
        message: { raw: hashMessage(message) },
      });
    },
    [account, signMessageAsync],
  );

  return {
    signData,
    isPending,
  };
};
